<template>
  <li :class="classes" @mouseenter="$_handleMouseenter" @mouseleave="$_handleMouseleave">
    <div ref="reference" :class="`${prefixMenuClass}__submenu-title`" @click.stop="$_handleClick($event)">
      <slot name="title"></slot>
      <i :class="iconClasses"></i>
    </div>
    <template v-if="openPosition === 'down'">
      <t-collapse-transition>
        <ul v-show="opened" :class="submenuClass">
          <slot></slot>
        </ul>
      </t-collapse-transition>
    </template>
    <transition v-else :name="transitionName">
      <ul v-show="opened"
          :style="dropStyle"
          :class="rightModeMenuClass"
          placement="bottom"
          style="margin-top: 0;"
      >
        <slot></slot>
      </ul>
    </transition>
  </li>
</template>

<script>
import MenuMixin from './menu-mixin'
import { PREFIX_CLASS } from '@/utils/constants'
const PREFIX_MENU_CLASS = `${PREFIX_CLASS}menu`
export default {
  name: 'TSubmenu',
  mixins: [MenuMixin],
  props: {
    name: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showTimeout: {
      type: Number,
      default: 300
    },
    hideTimeout: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      prefixMenuClass: PREFIX_MENU_CLASS,
      items: {},
      submenus: {},
      timeout: null,
      subMenuActive: false
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIX_MENU_CLASS}__submenu`,
        {
          [`${PREFIX_MENU_CLASS}--open ${PREFIX_CLASS}dropdown--open`]: this.opened === true,
          [`${PREFIX_MENU_CLASS}__submenu--checked`]: this.active || this.subMenuActive,
          [`dropright`]: this.openPosition === 'right' || this.collapse,
          [`${PREFIX_MENU_CLASS}__submenu--disabled`]: this.disabled
        }
      ]
    },
    iconClasses() {
      return [
        `${PREFIX_MENU_CLASS}__submenu-title-icon`
      ]
    },
    transitionName() {
      if (this.collapse) {
        return 'zoom-in-left'
      } else {
        if (this.openPosition === 'right' && this.opened === true) {
          return 'fade'
        } else {
          return ''
        }
      }
    },
    collapse() {
      return this.rootMenu.collapse
    },
    openPosition() {
      if (this.collapse) {
        return 'right'
      } else {
        return this.rootMenu.openPosition
      }
    },
    accordion() {
      return this.rootMenu.accordion
    },
    opened() {
      return this.rootMenu.openedMenus.includes(this.name)
    },
    triggerType() {
      if (this.rootMenu.openPosition === 'right' || this.collapse) {
        return 'hover'
      } else {
        return 'click'
      }
    },
    submenuClass() {
      return [
        `${PREFIX_MENU_CLASS}`,
        {
          [`${PREFIX_CLASS}dropdown__menu`]: this.openPosition === 'right',
          [`${PREFIX_MENU_CLASS}__vertical`]: this.openPosition !== 'right'
        }
      ]
    },
    dropStyle() {
      let style = {}

      // if (this.dropWidth) style.minWidth = `${this.dropWidth}px`
      return style
    },
    rightModeMenuClass() {
      return [
        `${PREFIX_CLASS}dropdown__menu`
      ]
    },
    active() {
      let isActive = false
      const items = this.items
      Object.keys(items).forEach(index => {
        if (items[index].active) {
          isActive = true
        }
      })
      return isActive
    }
  },
  watch: {
    active(value) {
      if (this.parentMenu && this.parentMenu.$options.name === 'TSubmenu') {
        this.parentMenu.$_updateSubmenuActive(value)
      }
    }
  },
  created() {
    if (this.parentMenu && this.parentMenu.$options.name === 'TSubmenu') {
      this.parentMenu.$_addSubItem(this)
    }
  },
  beforeDestroy() {
    if (this.parentMenu && this.parentMenu.$options.name === 'TSubmenu') {
      this.parentMenu.$_removeSubItem(this)
    }
  },
  methods: {
    $_updateSubmenuActive(flag) {
      this.subMenuActive = flag
    },
    $_handleClick() {
      if (this.triggerType !== 'click') {
        return
      }
      this.rootMenu.$_toggleSubmenu(this.name)
    },
    $_handleMouseenter(e, showTimeout = this.showTimeout) {
      if (this.triggerType !== 'hover') {
        return
      }
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.rootMenu.$_toggleSubmenu(this.name, false)
      }, showTimeout)
    },
    $_handleMouseleave() {
      if (this.triggerType !== 'hover') {
        return
      }
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.rootMenu.$_toggleSubmenu(this.name, true)
      }, this.hideTimeout)
    },
    $_addItem(item) {
      this.$set(this.items, item.name, item)
    },
    $_removeItem(item) {
      delete this.items[item.name]
    },
    $_addSubItem(subItem) {
      this.submenus[subItem.name] = subItem
    },
    $_removeSubItem(subItem) {
      delete this.submenus[subItem.name]
    },
    $setActive(val) {
      this.active = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/menu/submenu.vue